import { css } from '@emotion/core';
export { filter, title } from './shared.style';
export var select = {
  name: "nwuz4x",
  styles: "display:inline-block;width:112px;margin-right:16px;vertical-align:top;button{line-height:20px;}"
};